module.exports = __webpack_public_path__ + "img/error_logo.bebae871.png";